import * as Yup from 'yup';
import { createPost, updatePost, deletePostPhoto } from '../../reducers/feed/feed.actions';
import i18n from 'i18next';
import { checkFileSize, getLaravelValidationErrors,  getFormat, isVideo, isImage } from '../../helpers';

const formik = ({ dispatch, history, location, initialValues }) => {
  const { files, body, price, postPublic, deleteMedia } = initialValues;
  return {
    enableReinitialize: true,
    initialValues: {
      body,
      public: postPublic === 1,
      price,
      files,
      deleteMedia,
    },
    validationSchema: Yup.object().shape({
      price: Yup.number()
        .positive('Price must be a positive number')
        .test('price check if paid', i18n.t('Price is required'), function (value) {
          if (!this.parent.public) {
            return !isNaN(value) && !!value;
          }
          return true;
        }),
      files: Yup.array()
        .test('file-types', i18n.t("You can only upload either image/images or a video in one post."), files => {
          if (files.length > 1) {
            return files.map(file => getFormat(file.orig_src ? file.orig_src : file.file.name)).every((curr, index, arr) =>
              curr === arr[0]
            );
          }
          return true;
        })
         .test('video-type', i18n.t('Only one video is able to upload'), files => {
          const videoFiles = files.filter((file)=>file.mime_type === 'video' || file.image === false)
          return videoFiles.length < 2 
        })

        .test('file-size', i18n.t(`File shouldn't exceed 256mb`), files => {
          for (let i = 0; i < files.length; i++) {
            if (!checkFileSize(files[i].file)) {
              return false;
            }
          }
          return true;
        })
        
        .test('file-format', i18n.t("File is not supported"), files => files.every(file => 
          isVideo(file.orig_src ? file.orig_src : file.file.name) ||
          isImage(file.orig_src ? file.orig_src : file.file.name))
        )
        .test('file-length', i18n.t('The maximum amount of photos should not exceed 10.'), files => {

          if(files.length > 10){
            return false;
          }
          return true;
        })
    }),
    onSubmit: (values, { setStatus, setSubmitting, resetForm }) => {
      const files = [];
      if (values.deleteMedia.length) {
        values.deleteMedia.forEach(image => {
          files.push(dispatch(deletePostPhoto(image.id)));
        });
      }

      const updatePostFun = () => {
        dispatch(
          updatePost(location?.state, {
            ...values,
            public: values.public ? 1 : 0,
            files: values.files.map(el => el.file),
          })
        )
        .then(resp => {
          // setStatus({ success: true, id: location.state });
          setSubmitting(false);
          history.goBack();

          /* history.push(SINGLE_POST.replace(':id', resp.id));*/
        })
        .catch(errors => {
          console.log('Create post form errors', errors);
          setStatus({ errors: getLaravelValidationErrors(errors) });
          setSubmitting(false);
        });
      }

      if (files.length) {
        Promise.all(files).finally(() => updatePostFun());
      } else {
        updatePostFun();
      }
    },
  };
};

export default formik;
